'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _models = require('../actions/models');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchModels),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchModel),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editModel),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchModelsRequest),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchModelRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(editModelRequest);

function fetchModels(_ref) {
    var filter = _ref.filter;
    var disciplineId, response;
    return regeneratorRuntime.wrap(function fetchModels$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    disciplineId = filter.disciplineId;
                    _context.next = 4;
                    return (0, _effects.call)(_api.request, 'get', '/models?disciplineId=' + disciplineId);

                case 4:
                    response = _context.sent;
                    _context.next = 7;
                    return (0, _effects.put)(_models.actionCreators.fetchModelsSucceeded(response.data, filter));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_models.actionCreators.fetchModelsFailed('Ocorreu um erro na busca de quadros'));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchModel(_ref2) {
    var modelId = _ref2.modelId;
    var response;
    return regeneratorRuntime.wrap(function fetchModel$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/models/' + modelId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_models.actionCreators.fetchModelSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_models.actionCreators.fetchModelFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editModel(_ref3) {
    var modelId = _ref3.modelId,
        model = _ref3.model,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function editModel$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/models/' + modelId, model);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_models.actionCreators.editModelSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_models.actionCreators.editModelFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function fetchModelsRequest() {
    return regeneratorRuntime.wrap(function fetchModelsRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_models.actionTypes.FETCH_MODELS_REQUEST, fetchModels);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

function fetchModelRequest() {
    return regeneratorRuntime.wrap(function fetchModelRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_models.actionTypes.FETCH_MODEL_REQUEST, fetchModel);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function editModelRequest() {
    return regeneratorRuntime.wrap(function editModelRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_models.actionTypes.EDIT_MODEL_REQUEST, editModel);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

exports.default = [fetchModelsRequest, fetchModelRequest, editModelRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/models.js
// module id = 2233
// module chunks = 0